import { httpRequest } from "@services/http";

export interface JourneySummary {
  id: number;
  name: string;
  industry: string | null;
  is_master: boolean | null;
}

export class CommandListJourneys {
  async run(): Promise<JourneySummary[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/journeys/`;
    return await httpRequest<JourneySummary[]>(url, { method: "GET" });
  }
}
